module.exports = __webpack_public_path__ + "img/work-confianca.f1858ea4.png";